import { FunctionComponent } from 'react';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Grid2,
    Stack,
    Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ProductPerson } from '@starjack/entities/product';
import { getMoneyAsString } from '@starjack/entities/money/lib/utils';
import { formatStarjackDate } from '@starjack/utils';

type PersonAccordionProps = {
    person: ProductPerson;
};

export const PersonAccordion: FunctionComponent<PersonAccordionProps> = ({
    person,
}) => (
    <Accordion elevation={2}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Stack direction='row' spacing={1} alignItems='center'>
                <Typography fontWeight={500}>{person.name.de}</Typography>
                <Typography variant='body2' color='text.secondary'>
                    ({formatStarjackDate(person.birthday.from)} -{' '}
                    {formatStarjackDate(person.birthday.to)})
                </Typography>
            </Stack>
        </AccordionSummary>
        <AccordionDetails>
            <Grid2 container spacing={1}>
                <Grid2 size={4}>
                    <Typography variant='body2' fontWeight={600}>
                        Gültig von
                    </Typography>
                </Grid2>
                <Grid2 size={4}>
                    <Typography variant='body2' fontWeight={600}>
                        Gültig bis
                    </Typography>
                </Grid2>
                <Grid2
                    size={4}
                    sx={{
                        textAlign: 'right',
                    }}
                >
                    <Typography variant='body2' fontWeight={600}>
                        Preis
                    </Typography>
                </Grid2>
                {person.prices.map((price) => (
                    <Grid2
                        container
                        spacing={1}
                        key={price.id}
                        size={12}
                        sx={{
                            borderRadius: 1,
                            '&:hover': {
                                backgroundColor: 'action.hover',
                            },
                        }}
                    >
                        <Grid2 size={4}>
                            <Typography variant='body2'>
                                {formatStarjackDate(price.validity.from)}
                            </Typography>
                        </Grid2>
                        <Grid2 size={4}>
                            <Typography variant='body2'>
                                {formatStarjackDate(price.validity.to)}
                            </Typography>
                        </Grid2>
                        <Grid2
                            size={4}
                            sx={{
                                textAlign: 'right',
                            }}
                        >
                            <Typography variant='body2'>
                                {getMoneyAsString(price.price)}
                            </Typography>
                        </Grid2>
                    </Grid2>
                ))}
            </Grid2>
        </AccordionDetails>
    </Accordion>
);
